module.exports = __webpack_public_path__ + "img/36-l.e10106e0.png";